import {Component, Input} from '@angular/core';
import {DialogContentBase, DialogRef} from '@progress/kendo-angular-dialog';

@Component({
    selector: 'app-conflict-dialog',
    templateUrl: './conflict-dialog.component.html',
    styleUrls: ['./conflict-dialog.component.scss']
})
export class ConflictDialogComponent extends DialogContentBase {
    @Input() message: string;

    constructor(public dialog: DialogRef) {
        super(dialog);
    }
}
